export enum ErrorType{
    NO_DATA_FOUND,
    UNAUTORIZED
}